import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { CompatibleSocket } from "~/app/types/CompatibleSocket";

import { AppHeader } from "../UI/AppHeader";
import { AppSettingsUI } from "./App/AppSettingsUI";

export interface SettingsManagerUIProps {
  onClose: () => void;
  partySocket: CompatibleSocket;
}

export const SettingsManagerUI = ({
  partySocket: _partySocket,
  onClose,
}: Readonly<SettingsManagerUIProps>) => {
  return (
    <div className="flex h-full max-h-screen flex-col overflow-hidden">
      <AppHeader title="Settings">
        <Button
          onClick={onClose}
          variant="ghost"
          size="sm"
          className="h-6 px-2 text-gray-600 hover:text-gray-900"
        >
          <X className="h-4 w-4" />
        </Button>
      </AppHeader>

      <div className="flex flex-grow flex-col overflow-hidden">
        <div className="flex-grow overflow-hidden">
          <AppSettingsUI />
        </div>
      </div>
    </div>
  );
};
